/**
 * @format
 * @flow
 */
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import App from "./App";
// 施設ユーザーstore
import User from "./User";

import Task from "./Task";

import Setting from "./Setting";

import Template from "./Template";

const rootReducer = history =>
    combineReducers({
        App,
        User,
        Task,
        Setting,
        Template,
        router: connectRouter(history)
    });

export default rootReducer;
